var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"lHr lpR fFf"}},[_c('AppHeader',{attrs:{"use-reports":true,"onSetRightDrawerState":false}}),_c('q-page-container',{staticClass:"bg-accent"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }